import React from 'react';
import ReactDOM from 'react-dom/client'; // Note the updated import
import axios from 'axios';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import Store from './redux/store';

axios.defaults.withCredentials = true;

// Create a root container
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app
root.render(
  // <React.StrictMode>
  <Provider store={Store}>
    <App />
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
